/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Proposals API
 * Moment's Proposals API allows Clients to manage optimization proposals.
 * OpenAPI spec version: 1.0.0
 */

export type LadderPolicyConstraintType = typeof LadderPolicyConstraintType[keyof typeof LadderPolicyConstraintType];


export const LadderPolicyConstraintType = {
  ladder_policy: 'ladder_policy',
} as const;
